import React from 'react'
import './CSS/App.css';
import './CSS/Projects.css'
import './CSS/NavBar.css';
import './CSS/Banner.css';
import { Banner } from './components/Banner';
import { NavBar } from './components/NavBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Contact } from './components/Contact';

function App() {
  return (
    <div className="App">
      <NavBar/>
      <Banner />
      <Skills/>
      <Projects/>
      <Contact/>
    </div>
  );
}

export default App;
